module.exports = __webpack_public_path__ + "static/media/benchmark-bkg-3.8c73b561.svg";